<p-dialog
  header="Госуслуги недоступны !"
  [(visible)]="esiaErrorMessage"
  [modal]="true"
  [closable]="true"
  [style]="{ width: '50vw' }"
  [breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="field-wrap">
    <p>{{ esiaErrorMessage }}</p>
  </div>
</p-dialog>

<p-dialog
  header="Ошибка авторизации через Tinkoff ID"
  [(visible)]="tidError"
  [modal]="true"
  [closable]="true"
  [style]="{ width: '50vw' }"
  [breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="field-wrap">
    <p>Сервис Тинькофф не отвечает - заполните анкету самостоятельно</p>
  </div>
</p-dialog>

<div
  [ngClass]="[brand === 'VIVUS' ? 'vivus-style' : '', isMobile ? 'mobile' : '']"
>
  <app-registration-progress-bar [activeIndex]="0" *ngIf="!isMobile"></app-registration-progress-bar>
  <div class="container">
    <div class="row justify-content-center mb-5">
      <div class="col-md-4 col-xs-12 col-sm-8 container-landscape">
        <app-registration-progress-bar [activeIndex]="0" *ngIf="isMobile"></app-registration-progress-bar>
        <app-vpn-banner/>
        <div class="row flex-column align-items-center">
          <div class="col-12">
            <app-title *ngIf="!isMobile">Укажите ваши данные</app-title>
          </div>
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <div class="esia-text">
                <span class="esia-link">Заполнить быстро через</span>
              </div>
              <app-ui-helper *ngIf="!esiaAuth">
                <p>
                  Для быстрого прохождения регистрации авторизуйтесь в
                  сервисе Госуслуг и разрешите сервису доступ к данным.
                </p>
                <p>
                  Если ваша учетная запись подтверждена, система
                  заполнит необходимую персональную информацию.
                </p>
              </app-ui-helper>
            </div>
            <div class="d-flex align-items-center justify-content-center flex-sm-row flex-column">
              <a [href]="esiaPath" *ngIf="esiaAvailabilityStatus" class="esia-block" (click)="eventAnalytic()">
                <img
                  class="esia-logo"
                  ngSrc="assets/images/esia-logo.svg"
                  alt="Госуслуги" height="16" width="16"/>
              </a>
              <div id="tid-button-container">
              </div>
            </div>
            <app-title *ngIf="esiaAuth">
              Авторизация успешна, дозаполните недостающие данные
            </app-title>
          </div>
        </div>
        <form
          [formGroup]="registrationForm"
          autocomplete="off"
          (paste)="clientActionService.onPaste($event)"
        >
          <span [class]="registrationValid" *ngIf="!isMobile">* Обязательно для заполнения</span>
          <div class="row flex-column align-items-center">
            <div class="col-12">
              <app-autocomplete-fio
                fieldName="lastName"
                label="Фамилия"
                [formGroup]="registrationForm"
                part="SURNAME"
                [disableRequiredIdentifier]="!isMobile"
                [disableRequiredIdentifierLabel]="isMobile"
                appAnalytics
              >
              </app-autocomplete-fio>

              <app-autocomplete-fio
                fieldName="firstName"
                label="Имя"
                [formGroup]="registrationForm"
                part="NAME"
                [disableRequiredIdentifier]="!isMobile"
                [disableRequiredIdentifierLabel]="isMobile"
                appAnalytics
              >
              </app-autocomplete-fio>

              <app-autocomplete-fio
                fieldName="middleName"
                label="Отчество"
                [formGroup]="registrationForm"
                part="PATRONYMIC"

                appAnalytics
              >
              </app-autocomplete-fio>

              <app-gender-box
                [formGroup]="registrationForm"
                fieldName="gender"
                [disableRequiredIdentifier]="!isMobile"
                [disableRequiredIdentifierLabel]="isMobile"
              ></app-gender-box>

              <app-autocomplete-email
                fieldName="email"
                label="Электронный адрес"
                [formGroup]="registrationForm"
                [disableRequiredIdentifier]="!isMobile"
                [disableRequiredIdentifierLabel]="isMobile"
                appAnalytics
              >
              </app-autocomplete-email>

              <app-phone-field
                [formGroup]="registrationForm"
                fieldName="mainPhone"
                [disableRequiredIdentifier]="!isMobile"
                placeholder="Мобильный телефон"
                [disableRequiredIdentifierLabel]="isMobile"
                appAnalytics
              >
              </app-phone-field>

              <app-checkbox
                [formGroup]="registrationForm"
                fieldName="rulesAccepted"

              >
                <span class="checkbox-link"
                >Я ознакомлен и согласен с&nbsp;</span
                >
                <a [href]="rulesLink" target="_blank">Правилами</a>
              </app-checkbox>

              <div *ngIf="isMobile" class="col-12 d-flex justify-content-center mt-2 mb-2">
                <p-button
                  type="submit"
                  class="button btn-agreement-next"
                  label="Принять и продолжить"
                  (keydown.enter)="sendWithCaptcha(registrationForm)"
                  (onClick)="sendWithCaptcha(registrationForm)"
                  [loading]="isButtonDisable"
                ></p-button>
              </div>

              <span class="agreement-link"
                    (click)="showAdditionalAgreements()">Изменить часть согласий</span>

              <div [hidden]="!agreementAdvtFlag">

                <span class="agreement-adv-text">
                  <b>В случае, если вы НЕ СОГЛАСНЫ на передачу данных одному или нескольким третьим лицам, отзовите свое согласие из списка ниже</b>
                </span>

                <app-checkbox
                  [formGroup]="agreementsGroup"
                  fieldName="agreement1"
                >
                  <a class="checkbox-link"
                     [href]="documentLinks[0]"
                     target="_blank"
                  >Правила предоставления и обслуживания микрозаймов ООО МКК «СМСФИНАНС»</a>
                </app-checkbox>

                <app-checkbox
                  [formGroup]="agreementsGroup"
                  fieldName="agreement2"
                >
                  <a class="checkbox-link"
                     [href]="documentLinks[1]"
                     target="_blank"
                  >Общие условия договора потребительского микрозайма ООО МКК «СМСФИНАНС»</a>
                </app-checkbox>

                <app-checkbox
                  [formGroup]="agreementsGroup"
                  fieldName="agreement3"
                >
                  <a class="checkbox-link"
                     [href]="documentLinks[2]"
                     target="_blank"
                  >Договор принятия на обслуживание ООО МКК «СМСФИНАНС»</a>
                </app-checkbox>

                <app-checkbox
                  [formGroup]="agreementsGroup"
                  fieldName="agreement4"
                >
                  <a class="checkbox-link"
                     [href]="documentLinks[3]"
                     target="_blank"
                  >Правила пользования сайтами ООО МКК «СМСФИНАНС»</a>
                </app-checkbox>

                <app-checkbox
                  [formGroup]="agreementsGroup"
                  fieldName="agreement5"
                >
                  <a class="checkbox-link"
                     [href]="documentLinks[4]"
                     target="_blank"
                  >Соглашение об использовании аналога собственноручной подписи ООО МКК «СМСФИНАНС»</a>
                </app-checkbox>

                <app-checkbox
                  [formGroup]="agreementsGroup"
                  fieldName="agreement6"
                >
                  <a class="checkbox-link"
                     [href]="documentLinks[5]"
                     target="_blank"
                  >Согласие на обработку персональных данных посетителя сайта ООО МКК «СМСФИНАНС»</a>
                </app-checkbox>

                <app-checkbox
                  [formGroup]="agreementsGroup"
                  fieldName="agreement7"
                >
                  <a class="checkbox-link"
                     [href]="documentLinks[6]"
                     target="_blank"
                  >Согласие с условиями осуществления переводов денежных средств без открытия счета с использованием
                    сервиса «Быстрый платеж через ЮMoney»</a>
                </app-checkbox>

                <app-checkbox
                  [formGroup]="agreementsGroup"
                  fieldName="agreement8"
                >
                  <a class="checkbox-link"
                     [href]="documentLinks[7]"
                     target="_blank"
                  >Согласие на получение кредитного отчёта ООО МКК «СМСФИНАНС»</a>
                </app-checkbox>

                <app-checkbox
                  [formGroup]="agreementsGroup"
                  fieldName="agreement9"
                >
                  <a class="checkbox-link"
                     [href]="documentLinks[8]"
                     target="_blank"
                  >Согласие на получение рекламы ООО МКК «СМСФИНАНС»</a>
                </app-checkbox>

                <div class="question-button">
                  <p-overlayPanel #op [dismissable]="false" [style]="{'width': '333px'}">
                    <ng-template pTemplate="content">
                      <button type="button" (click)="op.hide()"
                              [class]="'p-ripple p-element p-overlaypanel-close p-link ' +
                              (brand === 'VIVUS' ? 'p-question-button-viv' : 'p-question-button-sms')">
                        <span class="p-overlaypanel-close-icon pi pi-times"></span>
                        <span class="p-ink"></span>
                      </button>
                      <div
                        [ngClass]="['additional-confirmation-text', brand === 'VIVUS' ? 'vivus-style' : '']">
                        <app-checkbox
                          [formGroup]="partnersAgreements"
                          fieldName="partnersAgreement1"
                        >
                          <span class="checkbox-link"
                          >«Национальное бюро кредитных историй»</span>
                        </app-checkbox>

                        <app-checkbox
                          [formGroup]="partnersAgreements"
                          fieldName="partnersAgreement2"
                        >
                          <span class="checkbox-link"
                          >«Бюро кредитных историй «Скоринг бюро»</span>
                        </app-checkbox>

                        <app-checkbox
                          [formGroup]="partnersAgreements"
                          fieldName="partnersAgreement3"
                        >
                          <span class="checkbox-link"
                          >ПАО «Вымпелкоммуникации»</span>
                        </app-checkbox>

                        <app-checkbox
                          [formGroup]="partnersAgreements"
                          fieldName="partnersAgreement4"
                        >
                          <span class="checkbox-link"
                          >ПАО «Мобильные Телесистемы»</span>
                        </app-checkbox>

                        <app-checkbox
                          [formGroup]="partnersAgreements"
                          fieldName="partnersAgreement5"
                        >
                          <span class="checkbox-link"
                          >ПАО «Мегафон»</span>
                        </app-checkbox>

                        <app-checkbox
                          [formGroup]="partnersAgreements"
                          fieldName="partnersAgreement6"
                        >
                          <span class="checkbox-link"
                          >ООО «Т2 Мобайл»</span>
                        </app-checkbox>

                        <app-checkbox
                          [formGroup]="partnersAgreements"
                          fieldName="partnersAgreement7"
                        >
                          <span class="checkbox-link"
                          >ООО «Комлинк Корп»</span>
                        </app-checkbox>

                        <app-checkbox
                          [formGroup]="partnersAgreements"
                          fieldName="partnersAgreement8"
                        >
                          <span class="checkbox-link"
                          >ООО «Фастком»</span>
                        </app-checkbox>

                        <app-checkbox
                          [formGroup]="partnersAgreements"
                          fieldName="partnersAgreement9"
                        >
                          <span class="checkbox-link"
                          >АО «Д2 Страхование»</span>
                        </app-checkbox>

                        <app-checkbox
                          [formGroup]="partnersAgreements"
                          fieldName="partnersAgreement10"
                        >
                          <span class="checkbox-link"
                          >ООО «Миллениал Групп»</span>
                        </app-checkbox>

                        <app-checkbox
                          [formGroup]="partnersAgreements"
                          fieldName="partnersAgreement11"
                        >
                          <span class="checkbox-link"
                          >Страховое акционерное общество «ВСК»</span>
                        </app-checkbox>

                        <app-checkbox
                          [formGroup]="partnersAgreements"
                          fieldName="partnersAgreement12"
                        >
                          <span class="checkbox-link"
                          >ООО «ИТ Консул»</span>
                        </app-checkbox>
                      </div>
                    </ng-template>
                  </p-overlayPanel>
                </div>

                <div class="additional-checkbox">
                  <app-checkbox
                    [formGroup]="agreementsGroup"
                    fieldName="agreement10"
                  >
                    <a class="checkbox-link" [href]="documentLinks[9]"
                       target="_blank"
                    >Согласие на обработку персональных данных заёмщика ООО МКК «СМСФИНАНС»</a>
                  </app-checkbox>
                  <span class="additional-checkbox-item" (click)="op.toggle($event)">+</span>
                </div>

              </div>
            </div>
            <div *ngIf="!isMobile" class="col-12 d-flex justify-content-center mt-4">
              <p-button
                autofocus
                type="submit"
                class="button"
                label="Далее"
                (keyup.enter)="sendWithCaptcha(registrationForm)"
                (onClick)="sendWithCaptcha(registrationForm)"
                [loading]="isButtonDisable"
              ></p-button>
            </div>
          </div>
        </form>
      </div>
      <app-gtm-container [stepNumber]="gtmStepNumber"></app-gtm-container>
    </div>
  </div>
</div>
